import type Plyr from 'plyr';
import { CustomElement } from '@/utils';

export default class Player extends CustomElement {
  static component = 'b-player';
  player: Plyr | null;
  constructor() {
    super();

    this.player = null;
    this.observe = true;
  }

  initObserved() {
    import('plyr').then((module) => {
      if (!module) return;
      const { default: Pl } = module;
      this.player = new Pl(this.$('main'), {
        controls: ['play-large', 'play', 'progress', 'mute', 'fullscreen'],
        hideControls: true,
        resetOnEnd: true,
        tooltips: { controls: false, seek: false },
      });
    });
  }
  destroyed() {
    if (this.player) {
      this.player.destroy();
    }
  }
}
